import {useTranslation} from "react-i18next";

export default function useGetRankingFilter () {
    const {t} = useTranslation();

    let rankingFilter = [
        {
            id : 0,
            name : t('sessionType')
        },
        {
            id : 1,
            name : t('yearsOld')
        },
        {
            id : 2,
            name : t('gender')
        },
        {
            id : 3,
            name : t('customField')
        },
        {
            id : 4,
            name : t('sessionTypeAndCustomField')
        }
    ];
    return rankingFilter;
}

export const RankingFilter = Object.freeze({
    TYPE: {
        id: 0,
        key: 'sessionType'
    },
    AGE: {
        id: 1,
        key: 'yearsOld'
    },
    GENDER: {
        id: 2,
        key: 'gender'
    },
    JOLLY: {
        id: 3,
        key: 'customField'
    },
    TYPE_JOLLY: {
        id: 4,
        key: 'sessionTypeAndCustomField'
    }
});